import { render, staticRenderFns } from "./AnnuityDetailStatusForm.vue?vue&type=template&id=2ccc9750&"
import script from "./AnnuityDetailStatusForm.vue?vue&type=script&lang=js&"
export * from "./AnnuityDetailStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./AnnuityDetailStatusForm.vue?vue&type=style&index=0&id=2ccc9750&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports